import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../../../styles/const/colors'

const useStyles = createUseStyles({
  adStoriesCard: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    minWidth: 195,
    maxWidth: 195,
    minHeight: 345,
    height: 345,
    border: `1px solid ${lightGrey}`,
    margin: '0 auto',
    overflow: 'hidden',
    marginBottom: 30,
    wordWrap: 'break-word',
    boxSizing: 'content-box',
    fontFamily: 'Roboto, sans-serif'
  }
})

export default useStyles
